export const boardLoader = {
  dashboardUp: 'dashboardUp',
  dashboardList: 'dashboardList',
  memberBoard: 'memberBoard',
  jobLevel: 'jobLevel',
};
export const InitialStateboard = {
  dashboardUp: true,
  dashboardList: true,
  memberBoard: true,
  jobLevel: true,
};
